export default {
	// normal

	social: {
		phoneOrEmailIsInCorrect: 'Phone or email is incorrect',
		resendOtpFailure: 'Unable to resend the OTP. Please try again.',
		maximumLength: 'Maximum {field} length is {number}',
	},
};
